import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../helpers/settings';
import { Result } from '../models/general';
import { RefreshVerificationService } from './refresh-verification.service';
import { InvoiceModel } from '../models/invoice-model';
import { ShippingConfig, ShippingModel } from '../models/shipping-model';
export interface PaginationData {
	docs: ShippingModel[];
	total: number;
	limit: number;
	page: number;
	pages: number;
}

@Injectable({
	providedIn: 'root'
})
export class ShippingModelService {
	readonly BASE_URL = `${GlobalVariable.server.host}/shipping-model`;

	constructor(private httpClient: HttpClient, private refreshVerifService: RefreshVerificationService) {}
	find(
		param: {
			fromConfigModelComponent?: boolean;
			fromAppComponent?: boolean;
			route?: string;
			projectId?: string;
			action?: string;
			attributes?: string;
		} = null
	): Observable<ShippingModel[]> {
		const { fromConfigModelComponent, fromAppComponent, route, projectId, action, attributes } = param;
		let params;
		if (fromConfigModelComponent) {
			params = new HttpParams()
				.set('fromConfigComponent', fromConfigModelComponent)
				.set('componentRoute', route)
				.set('actionName', action);
		} else if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId)
				.set('actionName', action);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent ?? false);
		}
		// params = params.set('attributes', attributes ?? null);
		return this.refreshVerifService.buidResult(
			this.httpClient.get<ShippingModel[]>(`${this.BASE_URL}/find`, { params })
		);
	}
	findByProject(projectId: string, fromAppComponent: boolean, route: string): Observable<ShippingModel[]> {
		let params;
		if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent);
		}
		return this.refreshVerifService.buidResult(
			this.httpClient.get<ShippingModel[]>(`${this.BASE_URL}/find-by-project/${projectId}`, { params })
		);
	}

	findById(id: string, fromAppComponent: boolean, route: string, projectId: string): Observable<ShippingModel> {
		let params;
		if (fromAppComponent) {
			params = new HttpParams()
				.set('fromAppComponent', fromAppComponent)
				.set('componentRoute', route)
				.set('projectId', projectId);
		} else {
			params = new HttpParams().set('fromAppComponent', fromAppComponent);
		}
		return this.refreshVerifService.buidResult(
			this.httpClient.get<ShippingModel>(`${this.BASE_URL}/find-by-id/${id}`, { params })
		);
	}

	create(shippingModel: Partial<ShippingModel>): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.post<Result>(`${this.BASE_URL}/create`, shippingModel)
		);
	}

	edit(shippingModel: Partial<ShippingModel>): Observable<Result> {
		return this.refreshVerifService.buidResult(this.httpClient.put<Result>(`${this.BASE_URL}/edit`, shippingModel));
	}

	delete(bookingModelId: string): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.delete<Result>(`${this.BASE_URL}/delete/${bookingModelId}`)
		);
	}

	updateShippingConfig(data: { shippingModel: string; shippingConfig: ShippingConfig }): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.put<Result>(`${this.BASE_URL}/shipping-config/${data.shippingModel}`, data)
		);
	}
	archive(bookingModelId: string): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.delete<Result>(`${this.BASE_URL}/archive/${bookingModelId}`)
		);
	}
	isUsed(bookingModelId: string): Observable<Result> {
		return this.refreshVerifService.buidResult(
			this.httpClient.get<Result>(`${this.BASE_URL}/if-is-Used/${bookingModelId}`)
		);
	}
}
